import { cn } from "@/utils/stylesUtils";

export function NavItem({ section, icon, label, selected, onClick }) {
  return (
    <div
      onClick={() => onClick(section)}
      className={cn(
        "flex items-center gap-2 text-[16px] cursor-pointer rounded py-1 px-2.5",
        selected === section && "bg-[#EBF5FF] font-bold",
      )}
    >
      <span className="shrink-0">{icon}</span>
      {label}
    </div>
  );
}
